export default{DEFAULTS:{},CURSOR:{GRABBING:"grabbing",GRAB:"grab",POINTER:"pointer"}};
//# sourceMappingURL=config.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-map-gl/dist/esm/config.js
// module id = 1720
// module chunks = 0